module.exports = __webpack_public_path__ + "img/clerk_weight_tarif_1.a0bbad55.png";